module.exports = __webpack_public_path__ + "img/Graph 2.8f1e671d.svg";